import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import IKanbanBoardProductionSchemaProps from "../../../Components/KanbanBoardProduction/interfaces/kanban-board-production-schema.interface";
import { useToast } from "../../../Hooks/ToasContext";
import { IServiceOrderEntity, optionsProductionStage as optionsProductionStageForSelect, ServiceOrderStatusEnum } from "../../../Services/api/service-orders/service-order.interface";
import { ListServiceOrdersUseCase } from "../../../Usecase/ServiceOrders/list-service-orders-usecase";
import { ShowServiceOrdersUseCase } from "../../../Usecase/ServiceOrders/show-service-orders-usecase";
import { UpdateServiceOrdersUseCase } from "../../../Usecase/ServiceOrders/update-service-orders-usecase";
import { labelsOrderProductionStatus } from "../../../utils/normalizeProductionStatus";
import { Task } from "../../Financial/Details/financial-details.hook";
import { format, parseISO } from "date-fns";
import { labelsOrderProductionStage } from "../../../utils/normalizeProductionStages";


interface IUseProductionDetailsProps {
  listServiceOrdersUseCase: ListServiceOrdersUseCase
  showServiceOrdersUseCase: ShowServiceOrdersUseCase
  updateServiceOrdersUseCase: UpdateServiceOrdersUseCase
  osId: string

}
export function useProductionDetails({ listServiceOrdersUseCase, showServiceOrdersUseCase, updateServiceOrdersUseCase, osId }: IUseProductionDetailsProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<any[]>([])

    const [kanbanSchema, setKanbanSchema] = useState<IKanbanBoardProductionSchemaProps>()
    const [orderDetails, setOrderDetails] = useState<IServiceOrderEntity | undefined>()

    const { showToast } =  useToast()

     const { handleSubmit, register, control, formState, watch } = useForm({
            // resolver: yupResolver(SignInSchemaValidation),
        });
        const { errors } = formState;

    const transformData = (dados: IServiceOrderEntity[]) => {
      
      const tasks: Record<string, Task> = {};
      const initialOS : any = [];
      const onProductionOS : any = [];
      const finishsedOS : any = [];
      
      dados.forEach((item, index) => {
          // const taskId = `task-${index + 1}`;
          const taskId = item.id;
          tasks[taskId] = {
              id: taskId,
              content: {
                  os: `OS #${item.externalProductionId}`,
                  items: item.products
              }
          };

          // if(item.stage === ServiceOrderStatusEnum.INITIAL){
          //   initialOS.push(taskId);
          // } else if (item.stage === ServiceOrderStatusEnum.EMITTED_OS){
          //   onProductionOS.push(taskId)
          // } else {
          //   finishsedOS.push(taskId)
          // }
          if(item.status === ServiceOrderStatusEnum.INITIAL){
            initialOS.push(taskId);
          } else if (Object.entries(item.status)
            .filter(([value]) => ![ServiceOrderStatusEnum.ERROR, ServiceOrderStatusEnum.PRODUCED, ServiceOrderStatusEnum.BILLED].includes(value as ServiceOrderStatusEnum))){
            onProductionOS.push(taskId)
          } else if (Object.entries(item.status)
            .filter(([value]) => [ServiceOrderStatusEnum.PRODUCED, ServiceOrderStatusEnum.BILLED].includes(value as ServiceOrderStatusEnum))){ 
            finishsedOS.push(taskId)
          }
          
      });

      const result = {
          tasks,
          columns: {
            [ServiceOrderStatusEnum.INITIAL]: {
                  id: ServiceOrderStatusEnum.INITIAL,
                  title: 'Aguardando Início',
                  taskIds: initialOS,
              },
              [ServiceOrderStatusEnum.PROCESSING]: {
                  id: ServiceOrderStatusEnum.PROCESSING,
                  title: 'Em Produção',
                  taskIds: onProductionOS,
              },
              [ServiceOrderStatusEnum.PRODUCED]: {
                  id: ServiceOrderStatusEnum.PRODUCED,
                  title: 'Produzido',
                  taskIds: finishsedOS,
              },
          },
          columnOrder: [ServiceOrderStatusEnum.INITIAL, ServiceOrderStatusEnum.PROCESSING, ServiceOrderStatusEnum.PRODUCED],
      };

      return result;
    }

    const ProductionDetails = async (currentPage: number) => {
        
        try {
          setLoading(true)
          
          const listResult = await listServiceOrdersUseCase.handle(currentPage);

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         const normalizeSchema : IKanbanBoardProductionSchemaProps = transformData(list?.data ?? [])
         setKanbanSchema(normalizeSchema)

       

         setPage(currentPage)
        } catch (error) {
          console.log("error ProductionDetails function: ", error)
        } finally {
          setLoading(false);
        }
      };

    const list = useMemo(() => {
        const rows = data?.map(sale => {
            return {
                ...sale,
                productionDueDate: format(parseISO(sale.productionDueDate), 'dd/MM/yyyy')
            }
        })

        return rows
    }, [data])

    const handleShowDetails = () => {
      
      // setShowDetails(code)
    } 

    const handleConfirmProductionItems = async ({ productId, status }: { status: ServiceOrderStatusEnum, productId: string }) => {
      try {
       
    
        setLoading(true)
        
        const updateResult = await updateServiceOrdersUseCase.handle({ productsIds: [productId], osId, status })

        if (updateResult.isFailure) {
          showToast(String(updateResult?.error?.error), 'error');
          return;
        }

        const dados = updateResult.getValue()
        
        showToast(String('Itens atualizados'), 'info', { vertical: 'bottom', horizontal: 'left' });
        handleShowDetails()
        
      } catch (error) {
        console.log("erro handleConfirmProductionItems: ", error)
      } finally {
        setLoading(false);
      }
    
    }

    const handleShowOrderDetails = async (osId: string) => {
        
      try {
        setLoading(true)
        
        const listResult = await showServiceOrdersUseCase.handle(osId)

        if (listResult.isFailure) {
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const dados = listResult.getValue()

       if(dados){
        const normalize = {
          ...dados,
          products: dados.products.map((product: any) => {
            return {
            ...product,
            productionDueDate: format(parseISO(product.productionDueDate), 'dd/MM/yyyy')
          }})
        }
        setOrderDetails(normalize)
       }

  
     
    
      } catch (error) {
        console.log("error ProductionDetails function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const optionsProductionStage = Object.entries(labelsOrderProductionStage)
    // .filter(([value]) => !["DEAD", "BILLED", "PROCESSING"].includes(value))
    .map(([value, label]) => ({
      label,
      value: value as ServiceOrderStatusEnum
    })); 


    return {
        loading,
        ProductionDetails,
        list,
        data,
        handleShowDetails,
        setOrderDetails,
        handleConfirmProductionItems,
        kanbanSchema,
        handleShowOrderDetails,
        orderDetails,
        register,
        control,
        errors,
        optionsProductionStage
        
    }
}